import { render, staticRenderFns } from "./DesiresAllocationAlgorithm.vue?vue&type=template&id=6d86ed52"
import script from "./DesiresAllocationAlgorithm.vue?vue&type=script&lang=js"
export * from "./DesiresAllocationAlgorithm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports